import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import {Link} from "react-router-dom";
import "./style.css";
import { useTranslation } from "react-i18next";
import { resolveFileUrl } from "constants/config";

const PARTNERS = [
    {
        id: "111",
        name: 'АНО "Больше, чем путешествие"',
        description: "",
        partner: "Партнер",
        url: 'https://morethantrip.ru/',
        // image: img_c
        image: "https://static.tildacdn.com/tild3137-6261-4365-b261-303939636636/photo.jpg"
    },
    {
        id: "111",
        name: 'Агентство стратегических инициатив',
        description: "",
        partner: "Партнер",
        url: 'https://asi.ru/',
        // image: img_c
        image: "https://alrf.ru/upload/resize_cache/iblock/d5b/1005_580_2/asi.png"
    },
    {
        id: "111",
        name: 'Федеральное агентство по делам молодёжи (Росмолодёжь)',
        description: "",
        partner: "Партнер",
        url: 'https://fadm.gov.ru/',
        // image: img_c
        image: "https://www.alumnirussia.org/upload/partners/original_b62f64741753c1e60dc459e1569dfbe0.png"
    },
    {
        id: "111",
        name: 'Российский союз молодёжи',
        description: "",
        partner: "Партнер",
        url: 'https://ruy.ru/',
        // image: img_c
        image: "https://chechenmol.ru/upload/000/u1/68/6f/18f82cbd.jpeg"
    },
    {
        id: "111",
        name: 'РДДМ "Движение Первых"',
        description: "",
        partner: "Партнер",
        url: 'https://будьвдвижении.рф/',
        // image: img_c
        image: "https://kalinovkasch.minobr63.ru/wp-content/uploads/2023/02/%D1%80%D0%B4%D0%B4%D0%BC-scaled.jpg"
    },
    {
        id: "111",
        name: 'Российские студенческие отряды',
        description: "",
        partner: "Партнер",
        url: 'https://трудкрут.рф /',
        // image: img_c
        image: "https://трудкрут.рф/theme/napravleniya2.png"
    },
    {
        id: "111",
        name: 'Молодежный клуб Русского географического общества',
        description: "",
        partner: "Партнер",
        url: 'https://mk.rgo.ru/',
        // image: img_c
        image: "https://www.rgo.ru/sites/default/files/styles/full_view/public/media/2016/10/emb.jpg?itok=GYDuUUOS"
    },
    {
        id: "111",
        name: 'Российский союз туриндустрии',
        description: "",
        partner: "Партнер",
        url: 'https://rostourunion.ru/',
        // image: img_c
        image: "https://tmsearch.onlinepatent.ru/images/90b/90b8b788-82a3-4dac-932f-eb31d5730aa0.jpg"
    },
];

export default function PartnersListTool(props) {
    const {
        partners = PARTNERS,
        is50 = true,
        isGreen = false,
        knowMore = true,
        onItemClick = item => {

        },
        cursor = 'pointer'
    } = props;

    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";


    return (
        <Wrapper>

            {partners.map((a, i) => {
                return (
                    <div style={{cursor: cursor, position: 'relative'}} className={`${is50 == true ? 'u-news-card-50' : 'u-news-card'} u-news-list__item u-news-card--default`} >
                        <div className="u-news-card__inner">
                            <div className="u-news-card__preview" onClick={() => {
                                onItemClick(a);
                            }} >
                                <img
                                    src={resolveFileUrl(a.image || a.avatar)}
                                    alt="Под полярным солнцем: как сити-фермы позволят выращивать растения в любой точке мира"
                                    className="u-news-card__image" />
                            </div>
                            <div className={`u-news-card__main ${isGreen == true ? 'purple_bg' : 'green_bg'}`} >
                                <time className="u-news-card__date u-news-card__date--over-image"> {a.partner}</time>
                                <div className="u-news-card__info">
                                    <h3 onClick={() => {
                                        onItemClick(a);
                                    }} >
                                        {a.name}
                                    </h3>

                                    {(a.contacts == undefined  || a.contacts == '') ? null :
                                        <div style={{fontSize: '20px', lineHeight: '24px', opacity: 0.7, fontFamily: 'Jost'}} onClick={() => {
                                            onItemClick(a);
                                        }} >
                                            {a.contacts}
                                        </div>
                                    }

                                    {a.url == undefined ? null :
                                        <button
                                            className="custom-button u-news-card__learn-more custom-button--size-sm custom-button--theme-outline-light"
                                            onClick={() => {
                                                window.open(a.url, "_blank");
                                            }}
                                        >

                                            <span className="custom-button__content more_button ">
                                                { isRu ? 'Узнать больше' : 'Learn more'}
                                            </span>

                                        </button>
                                    }

                                </div>
                            </div>
                        </div>

                        {(a.topText == undefined || a.topText == '') ? null :
                            <div style={{position: 'absolute', top: '30px', left: '30px'}} >
                                {a.topText}
                            </div>
                        }

                    </div>
                );
            })}

        </Wrapper>
    );
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -8px;
  justify-content: flex-start;
`;

const Card = styled.div`
  width: 100%;
  max-width: 33.3333333333%;
  display: block;
  color: #fff;
  text-decoration: none;
  transition: all .3s ease;
  --bg-color: #003dff;
`;

const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  height: 100%;
  min-height: 400px;
  border-radius: 16px;
  overflow: hidden;
`;

const CardPreview = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;